import { IonImg, IonLabel } from "@ionic/react";
import React, { useEffect } from "react";

const NotificationsBanner: React.FC = (props: any) => {
  return (
    <div className="nodata_img_parent">
      <IonImg src="/images/notifications_banner.svg" className="nodata_img" />
      <IonLabel className="notifications-banner">
        All updates related to your bookings, new offers & deals appear here
      </IonLabel>
    </div>
  );
};

export default NotificationsBanner;
